export const MAIN_CLASS_NAME = 'agent-page';
export const TITLE_CLASS_NAME = `${MAIN_CLASS_NAME}__title`;
export const CONTENT_CLASS_NAME = `${MAIN_CLASS_NAME}__content`;
